import posthog from "posthog-js";

// Project API keys are public by design — they are shipped inside the client
// bundle and can only write events. Env vars still take precedence so a fork or
// a staging build can point at a different project without a code change.
const POSTHOG_KEY =
  process.env.REACT_APP_PUBLIC_POSTHOG_KEY ||
  "phc_uy2Ws8rtdKMo6Uwv43Pv6S73TdNjSdCuLRuJpxLSe3C8";

const POSTHOG_HOST =
  process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

const ENVIRONMENT =
  process.env.REACT_APP_POSTHOG_ENVIRONMENT || process.env.NODE_ENV;

let ready = false;

export const isPostHogReady = () => ready;

export const initPostHog = () => {
  if (ready || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: "https://us.posthog.com",

    // Route changes are captured by PathTracker so that a single React Router
    // navigation produces exactly one $pageview.
    capture_pageview: false,
    capture_pageleave: true,

    // Everyone using FlexHR is behind Cognito, so anonymous profiles on the
    // login screen would only add cost without adding signal.
    person_profiles: "identified_only",

    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      // rrweb masks password inputs by default even when maskAllInputs is off.
      maskInputOptions: { password: false },
    },

    loaded: (ph) => {
      ph.register({ environment: ENVIRONMENT });
      if (process.env.NODE_ENV !== "production") ph.debug();
    },
  });

  ready = true;
};

export default posthog;
